import { render, staticRenderFns } from "./MultiBlobButton.vue?vue&type=template&id=8dd679e0&"
import script from "./MultiBlobButton.vue?vue&type=script&lang=js&"
export * from "./MultiBlobButton.vue?vue&type=script&lang=js&"
import style0 from "./MultiBlobButton.vue?vue&type=style&index=0&id=8dd679e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports